export const FORM_STATES = {
	FORM: 'FORM',
	LOADING: 'LOADING',
	TECHNICAL_ERROR: 'TECHNICAL_ERROR'
};
